document.addEventListener("DOMContentLoaded",()=>{
  let curDetailElement = null
  $('nav.header__inline-menu .header_inline_container>ul.list-menu.list-menu--inline>li').on('mouseenter', function(event) {
    curDetailElement?curDetailElement.removeAttr('open'):null;
    var firstChildTag = $(this).children().first().prop('tagName');
    if (firstChildTag === 'HEADER-MENU') {
      var detailsElement = $(this).find('details').eq(0);
      curDetailElement=detailsElement
      if (event.type === 'mouseenter') {
        detailsElement.attr('open', true);
        $(".mega-menu__overlay").show();
      }
    }
  });
  $(".header-wrapper").on("mouseleave",function(){
    if(curDetailElement){
      curDetailElement.removeAttr('open')
      $(".mega-menu__overlay").hide();
    }
  })
});